import ImageTextCard from "@/components/ui/image-text-card";
import ServicesForFamiliesCardImage from "@/assets/images/home/inquiry-thank-you-services-for-families-card-image.jpeg";
import LINKS from "@/lib/links";
import MedicalStaffingCardImage from "@/assets/images/home/inquiry-thank-you-medical-staffing-card-image.jpeg";
import AboutUsCardImage from "@/assets/images/home/inquiry-thank-you-about-us-card-image.jpeg";
import BlogsCardImage from "@/assets/images/home/inquiry-thank-you-blogs-card-image.jpeg";
import { CALLRAIL_HREF, CALLRAIL_PRETTY, cn } from "@/lib/utils";
import InlineButton from "@/components/ui/inline-button";
import { useWindowSize } from "@/hooks/use-window-size";

export interface InquiryThankYouProps {
  className?: string;
}

const InquiryThankYou: React.FC<InquiryThankYouProps> = ({ className }) => {
  const size = useWindowSize();

  return (
    <div
      className={cn(
        "flex w-full flex-col gap-6 md:gap-4 lg:max-w-[680px]",
        className
      )}
    >
      <h3 className="font-montserrat text-heading-4 text-secondary-500 md:text-heading-3">
        Thank you for the inquiry!
      </h3>
      <p className="font-roboto text-body-1-300 text-neutral-600">
        While you wait for us to get in touch, feel free to explore our website
        to learn more about us and how we can help you.
      </p>
      <p className="font-roboto text-body-1-300 text-neutral-600">
        If you have any urgent concerns, please don&apos;t hesitate to call us
        at
        <InlineButton
          href={CALLRAIL_HREF}
          color="orange"
          className="block md:inline-block"
          size={size === "sm" ? "sm" : "md"}
          id="hotline-inquiry-home-thank-you"
        >
          {CALLRAIL_PRETTY}
        </InlineButton>
      </p>

      <div className="mx-auto grid w-full grid-cols-1 gap-4 px-10 py-4 md:grid-cols-2 md:gap-x-10 md:gap-y-4 md:py-2 lg:w-auto">
        <ImageTextCard
          className="cols-span-1 w-full lg:max-w-[200px]"
          imageParentClassName="relative h-[120px] w-full overflow-hidden lg:aspect-[200/120] hidden md:block"
          image={{
            src: ServicesForFamiliesCardImage,
            alt: "Services for families card image",
          }}
          contentClassName="p-4"
          titleClassName="font-montserrat text-body-1-600"
          title="Services For Families"
          cta={{
            className: "font-medium text-xs font-montserrat",
            href: LINKS.servicesForFamilies.href,
            text: "Learn More",
          }}
        />
        <ImageTextCard
          className="cols-span-1 w-full lg:max-w-[200px]"
          imageParentClassName="relative h-[120px] w-full overflow-hidden lg:aspect-[200/120] hidden md:block"
          image={{
            src: MedicalStaffingCardImage,
            alt: "Medical staffing card image",
          }}
          contentClassName="p-4"
          titleClassName="font-montserrat text-body-1-600"
          title="Facilities"
          cta={{
            className: "font-medium text-xs font-montserrat",
            href: LINKS.medicalStaffing.href,
            text: "Learn More",
          }}
        />
        <ImageTextCard
          className="cols-span-1 w-full lg:max-w-[200px]"
          imageParentClassName="relative h-[120px] w-full overflow-hidden lg:aspect-[200/120] hidden md:block"
          image={{
            src: BlogsCardImage,
            alt: "Blogs card image",
          }}
          contentClassName="p-4"
          titleClassName="font-montserrat text-body-1-600"
          title="Blogs"
          cta={{
            className: "font-medium text-xs font-montserrat",
            href: LINKS.blogFamilies.href,
            text: "Read Our Blog",
          }}
        />
        <ImageTextCard
          className="cols-span-1 w-full lg:max-w-[200px]"
          imageParentClassName="relative h-[120px] w-full overflow-hidden lg:aspect-[200/120] hidden md:block"
          image={{
            src: AboutUsCardImage,
            alt: "About us card image",
          }}
          contentClassName="p-4"
          titleClassName="font-montserrat text-body-1-600"
          title="About Us"
          cta={{
            className: "font-medium text-xs font-montserrat",
            href: LINKS.aboutUs.href,
            text: "Discover Our Story",
          }}
        />
      </div>
    </div>
  );
};

export default InquiryThankYou;
